import { signal } from '@preact/signals-react';

import type { RestaurantModel } from '@/entities/restaurant/model';

const STORAGE_KEY = 'lastRestaurantSnapshot';

type RestaurantSnapshot = RestaurantModel & { cartId: string };

const current = signal<RestaurantSnapshot | null>(null);
const snapshot = signal<RestaurantSnapshot | null>(
  JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
);

function setRestaurant(restaurant: RestaurantModel | null) {
  if (!restaurant) {
    current.value = null;
    return;
  }

  if (snapshot.value && snapshot.value.id === restaurant.id) {
    const snap: RestaurantSnapshot = {
      ...restaurant,
      cartId: snapshot.value.cartId,
    };
    current.value = snap;
    snapshot.value = snap;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
    return;
  }

  // новый ресторан → новый cartId
  const cartId = crypto.randomUUID();
  const snap: RestaurantSnapshot = { ...restaurant, cartId };

  current.value = snap;
  snapshot.value = snap;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
}

function hydrateFromStorage() {
  if (!current.value && snapshot.value) {
    current.value = snapshot.value;
  }
}

export const restaurantStore = {
  current,
  snapshot,
  setRestaurant,
  hydrateFromStorage,
  get headerInfo() {
    return current.value ?? snapshot.value ?? null;
  },
  get cartId() {
    return current.value?.cartId ?? null;
  },
};
